import React, {Component} from 'react'
import styles from './Gallery.css'
import GalleryModal from './GalleryModal'
import ArrowLink from '../ArrowLink'

export default class Gallery extends Component {
  state = {
    showModal: false,
    lastClicked: 0,
  }

  handleClick = k => () => {
    this.setState({showModal: true, lastClicked: k})
  }

  quitModal = () => {
    this.setState({showModal: false, lastClicked: 0})
  }

  render () {
    return (
      <div className={styles.cont}>
        <div className={styles.thumbnails}>
          {
            this.props.gallery.map((item, k) => (
              <Item
                onClick={this.handleClick(k)}
                key={item.primaryTitle}
                {...item}
              />
            ))
          }
        </div>

        {
          this.state.showModal && (
            <GalleryModal
              gallery={this.props.gallery}
              quitModal={this.quitModal}
              initialSlide={this.state.lastClicked}
            />
          )
        }
      </div>
    )
  }
}

class Item extends Component {
  state = {
    height: null,
  }

  handleClick = () => {
    this.props.onClick()
  }

  render () {
    return (
      <div
        className={styles.item}
        style={{
          backgroundImage: 'url('+this.props.image+')',
          /*height: this.state.height ? this.state.height + 'px' : '',*/
        }}
        onClick={this.handleClick}
        ref={(cont) => {
          if (!this.state.height) {
            this.setState({
              height: cont && cont.clientWidth
            })
          }
        }}
      >
        <div className={styles.info}>
          <div>
            <div className={styles.primaryTitle}>{this.props.primaryTitle}</div>
            {this.props.year && (<div className={styles.year}>{this.props.year}</div>)}
            {this.props.secondaryTitle && (<div className={styles.secondaryTitle}>{this.props.secondaryTitle}</div>)}
          </div>
          <div className={styles.description}>{this.props.excerpt}</div>
          <ArrowLink theme='white'>Read more</ArrowLink>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Rist/modules/Gallery/index.js